// @flow
export const isPending = (state: Object): boolean => state.leagues.show_my.is_pending;

export const getError = (state: Object) => state.leagues.show_my.error;

export const getLeagues = (state: Object) =>
	state.leagues.show_my.ordered_ids.map(id => state.leagues.by_id[id]);


// WEBPACK FOOTER //
// ./src/modules/selectors/league/show_my.js